import api from '../../lib/api';


export const validateHash = h =>
  function get(dispatch) {
    console.log(`/public-assessment/${h}/`);
    api
      .sendGet(`/public-assessment/${h}/`, (error, response) => {
        if (error) return console.error(error);
        if (!response.data) {
          return dispatch(updateHashError(response.data));
        }
        return dispatch(validateHashSuccess(response.data));
      });
  };

export const validateHashSuccess = data => ({
  type: 'VALIDATE_HASH_SUCCESS',
  data,
});

export const updateHashError = data => ({
  type: 'VALIDATE_HASH_ERROR',
  data,
});



// WEBPACK FOOTER //
// ./src/Actions/Assessment/validateHash.js